import React from 'react';
import { Link } from '@remix-run/react';

interface Props {
    stats: {
        label: string;
        data: string;
        testID: string;
        additionalContent?: React.ReactNode;
        link?: string;
    }[];
}

/** Displays a list of metric stats with labels and values. */
const MetricStats = ({ stats }: Props) => {
    return (
        <div className="mb-60 ml-[2px] w-[434px] pt-[3px]">
            <ul className="block">
                {stats.map((s, index) => (
                    <li
                        key={s.testID}
                        className={`mb-0 block h-[148px] border-b border-black pt-5 ${index === 0 ? 'border-t-0' : 'border-t border-black'}`}
                    >
                        <span className="block text-[22px] font-normal uppercase leading-[1.1] tracking-[-0.02em] text-[#343434]">
                            {s.label}
                        </span>
                        <div className="flex justify-end">
                            <h3
                                className="relative top-[1.5px] m-0 pr-0 text-[55px] leading-[60.5px]"
                                data-testid={s.testID}
                            >
                                {s.link ? (
                                    <Link
                                        to={s.link}
                                        prefetch="intent"
                                        className="text-inherit underline transition-opacity hover:opacity-70"
                                    >
                                        {s.data}
                                    </Link>
                                ) : (
                                    s.data
                                )}
                            </h3>
                        </div>
                        {s.additionalContent}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MetricStats;
